class Slider {
  constructor(selector) {
    this.container = document.querySelector(selector);
    this.slides = this.container.querySelectorAll('img');
    this.index = 0;

    this.progressBar = this.container.querySelector('.progress-bar span'); // Progress bar element
    this.prevButton = this.container.querySelector('.prev');
    this.nextButton = this.container.querySelector('.next');

    this.init();
  }

  init() {
    if (this.slides.length > 0) {
      this.showSlide(this.index);
      this.addEventListeners();
    }
  }

  showSlide(index) {
    this.index = index;
    const totalSlides = this.slides.length;

    // Ensure active class is applied correctly for the index
    this.slides.forEach((slide, i) => {
      slide.classList.remove('active', 'fade-in');
      if (i === this.index) {
        slide.classList.add('active', 'fade-in');
      }
    });

    // Reset and start progress bar animation
    this.progressBar.style.width = '0';
    this.progressBar.style.animation = 'none'; // Reset animation
    setTimeout(() => {
      this.progressBar.style.animation = `progressBar ${
        3 // Set progress bar time to 3 seconds (change as needed)
      }s linear forwards`; // Restart animation
    }, 100);
  }

  nextSlide() {
    // If it's the last slide, reset to the first slide
    this.index = (this.index + 1) % this.slides.length;
    this.showSlide(this.index);
  }

  prevSlide() {
    // If it's the first slide, go back to the last slide
    this.index = (this.index - 1 + this.slides.length) % this.slides.length;
    this.showSlide(this.index);
  }

  addEventListeners() {
    this.prevButton.addEventListener('click', () => this.prevSlide());
    this.nextButton.addEventListener('click', () => this.nextSlide());
  }
}

// Export the Slider class to be used in other files
export default Slider;
